module.exports = __webpack_public_path__ + "img/_500.5b492a31.png";